<template>
	<div>
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div>
			<v-menu
				offset-y
				ref="menu"
				v-model="menu"
				min-width="auto"
				transition="scale-transition"
				:close-on-content-click="false"
				content-class="date-picker-menu-container"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						data-lpignore="true"
						:value="formattedDate"
						prepend-icon="mdi-calendar"
						readonly
						v-bind="attrs"
						v-on="on"
						:ref="fieldRef"
					></v-text-field>
				</template>
				<v-date-picker data-lpignore="true" ref="picker" :min="minDate" @change="save" :max="maxDate" v-model="localVal"></v-date-picker>
			</v-menu>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';

export default {
	name: 'DatePickerField',
	components: {
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin],
	computed: {
		formattedDate() {
			return this.localVal ? moment(this.localVal).format('MMMM Do YYYY') : '';
		},
		fieldValidations() {
			return this.fieldMetadata.validations;
		},
		minDateValidation() {
			return this.fieldValidations.min_date;
		},
		maxDateValidation() {
			return this.fieldValidations.max_date;
		},
		minDate() {
			if (this.minDateValidation.enabled) {
				return this.getIsoDate(this.minDateValidation.value);
			} else {
				return '';
			}
		},
		maxDate() {
			if (this.maxDateValidation.enabled) {
				return this.getIsoDate(this.maxDateValidation.value);
			} else {
				return '';
			}
		},
		prefillEnabled() {
			return this.fieldMetadata?.options?.prefill?.enabled;
		},
	},
	methods: {
		getIsoDate(dateStr) {
			if (!dateStr) {
				return '';
			} else {
				const date = new Date(dateStr);
				return date.toISOString();
			}
		},
		save() {
			this.menu = false;
		},
	},
	mounted() {
		if (this.prefillEnabled) {
			this.localVal = this.getProcessedValue(this.value);
		}
	},
	data: () => ({
		menu: false,
		localVal: null,
	}),
	watch: {
		localVal(newV) {
			this.value = newV;
		},
	},
};
</script>
<style scoped lang="scss">
.date-picker-menu-container {
	@media (max-width: 575px) {
		min-width: 290px !important;
	}
}
</style>
